export function getApiUrl() {
  return 'https://sa.sarv.com/api/';
}

// Get api endpoints dynamically
export function endPoints(title) {
  const version = 'v1/';
  const routes = {
    login: `${version}auth/login`,
    changePassword: `${version}auth/changePassword`,
    logout: `${version}auth/logout`,
    fetchKycUserList: `${version}kyc/fetchKycUserList`,
    getUserKycDoc: `${version}kyc/getUserKycDoc`,
    updateKycDocStatus: `${version}kyc/updateKycDocStatus`,
    updateKycStatus: `${version}kyc/updateKycStatus`,
    sendRejectedMail: `${version}kyc/sendRejectedMail`,
    consoleUsersList: `${version}users/consoleUsersList`,
    adminUsersList: `${version}admin/adminUsersList`,
    createAdminUser: `${version}admin/createUser`,
    advertisement: `${version}advertisment/upload`,
    consoleReferenceLogin: `${version}mis/consoleReferenceLogin`,
    getUserAccess: `${version}admin/getUserAccess`,
    updateUserDetails: `${version}admin/updateUserDetails`,
    updateUserStatus: `${version}admin/updateUserStatus`,
    getAgentDetails: `${version}crm/getAgentsDetails`,
    forceLogout: `${version}admin/forceLogout`,
    getCrmActivityLogs: `${version}crm/getCrmActivityLogs`,
    updateProfile: `${version}admin/updateProfile`,
    updateForceVerifyPermission: `${version}users/updateForceVerifyPermission`,
    getUserPassword: `${version}users/getUserPassword`,
    getAllAdmin: `${version}admin/getAllAdmin`,
    updateUserAdmin: `${version}users/updateUserAdmin`,
    updatePanelPermission: `${version}admin/updatePanelPermission`,
    getPanelPermission: `${version}admin/getPanelPermission`,
    createConsoleUser: `${version}admin/createConsoleUser`,
    fetchToken: `${version}auth/fetchToken`,
    fetchAnnouncementList: `${version}voice/fetchAnnouncementList`,
    updateAnnouncementStatus: `${version}voice/updateAnnouncementStatus`,
    fetchIvrList: `${version}voice/fetchIvrList`,
    updateIvrStatus: `${version}voice/updateIvrStatus`,
    updateConsoleUser: `${version}admin/updateConsoleUser`,
    consoleUserDetails: `${version}admin/consoleUserDetails`,
    getVoiceUserPlanNCredits: `${version}voice/getVoiceUserPlanNCredits`,
    getVoicePlanNCredits: `${version}voice/getVoicePlanNCredits`,
    assignPlanToVoiceUser: `${version}voice/assignPlanToVoiceUser`,
    removeVoiceUserPlan: `${version}voice/removeVoiceUserPlan`,
    assignCreditToVoiceUser: `${version}voice/assignCreditToVoiceUser`,
    assignTTSCreditToVoiceUser: `${version}voice/assignTTSCreditToVoiceUser`,
    getPlanList: `${version}plan/getPlanList`,
    updatePlan: `${version}plan/updatePlan`,
    addNewPlan: `${version}plan/addNewPlan`,
    deletePlan: `${version}plan/updatePlanStatus`,
    branding: `${version}mis/branding`,
    assignAMpass: `${version}admin/pass`,
    shiftAM: `${version}admin/shiftAM`,
    getAssignedView: `${version}admin/getAssignedView`,
    updateAssignedView: `${version}admin/updateAssignedView`,
    fetchTtsTemplate: `${version}voice/fetchTtsTemplates`,
    updateTemplateStatus: `${version}voice/updateTemplateStatus`,
    amAnalysis: `${version}admin/amAnalysis`,
    getTranslatedText: `${version}voice/getTranslatedText`,
    sendInvoice: `${version}invoice/sendInvoice`,
    getQuotationList: `${version}invoice/getQuotationList`,
    sendTaxInvoice: `${version}invoice/sendTaxInvoice`,
    getUserSettingsInfo: `${version}voice/getUserSettingIfno`,
    updateProfileSetting: `${version}voice/updateProfileSetting`,
    getLeadsAnalysis: `${version}admin/getLeadsAnalysis`,
    addBankDetails: `${version}invoice/addBankDetails`,
    addCompanyDetails: `${version}invoice/addCompanyDetails`,
    slabs: `${version}plan/planSlabs`,
    getLeadsAnalysis: `${version}admin/getLeadsAnalysis`,
    uploadInvoiceSignature: `${version}invoice/uploadInvoiceSignature`,
    getInvoiceAdditionalInfo: `${version}invoice/getInvoiceAdditionalInfo`,
    getColumnDetails: `${version}admin/getColumnDetails`,
    addWhatsappPlan: `${version}whatsapp/addWhatsappPlan`,
    getWhatsAppPlans: `${version}whatsapp/getWhatsAppPlans`,
    CAGetPlanNCredits: `${version}whatsapp/CAGetPlanNCredits`,
    assignWhatsAppAmountPlans: `${version}whatsapp/assignWhatsAppAmountPlans`,
    assignWhatsAppCreditPlans: `${version}whatsapp/assignWhatsAppCreditPlans`,
    removeUserPlan: `${version}whatsapp/removeUserPlan`,
    CAGetAllPlanNCredits: `${version}whatsapp/caGetAllPlanNCredits`,
    getWhatsappUserSettingsInfo: `${version}whatsapp/getUserSettingInfo`,
    updateWhatsappProfileSetting: `${version}whatsapp/updateProfileSetting`,
    webinarCount: `${version}webinar/webinarCount`,
    acitveMeetList: `${version}webinar/acitveMeetList`,
    upcomingMeetList: `${version}webinar/upcomingMeetList`,
    webinarMeetReport: `${version}webinar/webinarMeetReport`,
    webinarMeetParticipants: `${version}webinar/webinarMeetParticipants`,
    addVoicePlans: `${version}voice/addVoicePlans`,
    VoicePlansList: `${version}voice/VoicePlansList`,
    VoicePlansAssignAmount: `${version}voice/VoicePlansAssignAmount`,
    VoicePlansAssignNUpdateUserPlan: `${version}voice/VoicePlansAssignNUpdateUserPlan`,
    VoiceGetUserAmountPlanArrUser: `${version}voice/VoiceGetUserAmountPlanArrUser`,
    VoicegetCAUserBalance: `${version}voice/VoicegetCAUserBalance`,
    VoicegetAllplans: `${version}voice/VoicegetAllplans`,
    GetAllPlansCreditAmount: `${version}whatsapp/GetAllPlansCreditAmount`,
    addWhatsAppCreditPlans: `${version}whatsapp/addWhatsAppCreditPlans`,
    assignCreditToUser: `${version}whatsapp/assignCreditToUser`,
    getUserBalance: `${version}whatsapp/getUserBalance`,
    assignAmount: `${version}whatsapp/assignAmount`,
    email_stat_dashboard: `${version}email/email-stats-dashboard`,
    smtpList: `${version}server/getSmtpList`,
    addSmtp: `${version}server/addSmtp`,
    updateStatus: `${version}server/ChangeStatus`,
    VoiceChangeRecordStatus: `${version}voice/VoiceChangeRecordStatus`,
    fetchLogLevel: `${version}email/fetchLogLevel`,
    fetchLoggerEnv: `${version}email/fetchLoggerEnv`,
    changeLogLevel: `${version}email/changeLogLevel`,
    VoiceDeleteUserList: `${version}voice/VoiceDeleteUserList`,
    addGateway: `${version}sms/addgetway`,
    getListGateway: `${version}sms/listgetway`,
    getSmsTemplateList: `${version}sms/getTemplateList`,
    ChangeRecordStatus: `${version}sms/smsChangeRecordStatus`,
    getSmsSenderList: `${version}sms/getSenderIdList`,
    getUserPlanAndComment: `${version}plan/getUserPlanAndComment`,
    changeStatus: `${version}sms/changeStatus`,
    assignGateway: `${version}sms/assignGateway`,
    fetchConsoleAuthData: `${version}admin/fetchConsoleAuthData`,
    saveConsoleAuth: `${version}admin/saveConsoleAuth`,
    voiceChangeRecordRoute: `${version}voice/voiceChangeRecordRoute`,
    updateGateway: `${version}sms/updateGateway`,
    voiceCreditPlansInvoice: `${version}voice/voiceCreditPlansInvoice`,
    voiceAmountPlansInvoice: `${version}voice/voiceAmountPlansInvoice`,
    voiceDeleteCamapaignList: `${version}voice/deleteCampaignList`,
    voiceDeleteAmountPlanList: `${version}voice/deleteAmountPlan`,
    addSmsPlan: `${version}sms/addPlan`,
    getSmsPlansList: `${version}sms/getSmsPlansList`,
    getSmsAssignedPlanList: `${version}sms/getSmsAssignedPlanList`,
    assignSmsPlan: `${version}sms/assignSmsPlan`,
    getSmsUserAmount: `${version}sms/getSmsUserAmount`,
    assignAmountToUser: `${version}sms/assignAmountToUser`,
    getUserCampaignInvoiceList: `${version}voice/getUserCampaignInvoiceList`,
    getPaymentInvoiceList: `${version}invoice/getPaymentInvoiceList`,
    getSmsUserSettingInfo: `${version}sms/getSmsUserSettingInfo`,
    updateSmsProfileSetting: `${version}sms/updateSmsProfileSetting`,
    getlistEsBackupServer: `${version}voice/getlistEsBackupServer`,
    getAddEsBackupServer: `${version}voice/getAddEsBackupServer`,
    changeEsBackupServerStatus: `${version}voice/changeEsBackupServerStatus`,
    removeSmsUserPlan: `${version}sms/removeSmsUserPlan`,
    getNegativeUsersBalanceList: `${version}voice/getNegativeUsersBalanceList`,
    getVoiceHostList: `${version}voice/getVoiceHostList`,
    addVoiceHost: `${version}voice/addVoiceHost`,
    getVoiceGatewayList: `${version}voice/getVoiceGatewayList`,
    addVoiceGateway: `${version}voice/addVoiceGateway`,
    getHostIp: `${version}voice/getHostIp`,
    addVoiceGateway: `${version}voice/addVoiceGateway`,
    changeHostStatus: `${version}voice/changeHostStatus`,
    updateHost: `${version}voice/updateHost`,
    updateVoiceGateway: `${version}voice/updateVoiceGateway`,
    changeGatewayStatus: `${version}voice/changeGatewayStatus`,
    assignVoiceGateway: `${version}voice/assignVoiceGateway`,
    createGatewayQueue: `${version}voice/createGatewayQueue`,
    getfreeChannel: `${version}voice/getfreeChannel`,
    calltestGAteway: `${version}voice/calltestGateway`,
    getVoiceCliList: `${version}voice/getVoiceCliList`,
    getVoiceHostInfo: `${version}voice/getVoiceHostInfo`,
    getGatewaysArr: `${version}voice/getGatewaysArr`,
    addVoiceClis: `${version}voice/addVoiceClis`,
    updateVoiceClis: `${version}voice/updateVoiceClis`,
    assignRemoveVoiceClisFromUser: `${version}voice/assignRemoveVoiceClisFromUser`,
    uploadBulkAnnouncement: `${version}voice/uploadBulkAnnouncement`,
    addBulkTemplate: `${version}voice/addBulkTemplate`,
    uploadBulkUserByCsv: `${version}admin/uploadBulkUserByCsv`,
    adminSettingUpdate: `${version}voice/adminSettingUpdate`,
    deleteGateway: `${version}voice/deleteGateway`,
    removeNegativeBalanceUser: `${version}voice/removeNegativeBalanceUser`,
    getCampaignDtmfPressCount: `${version}voice/getCampaignDtmfPressCount`,
    getAdminSettings: `${version}voice/getAdminSettings`,
    getSmsRealNumberList: `${version}sms/getSmsRealNumberList`,
    smsAddNumber: `${version}sms/addNumber`,
    deleteNumber: `${version}sms/deleteNumber`,
    updateUnivarsalMockSetting: `${version}sms/updateUnivarsalMockSetting`,
    getUnivarsalMockSetting: `${version}sms/getUnivarsalMockSetting`,
    removeAssignGateway: `${version}sms/removeAssignGatewayToUser`,
    updateRetrySetting: `${version}sms/updateRetrySetting`,
    getRetrySetting: `${version}sms/getRetrySetting`,
    getAllocatedTps: `${version}sms/getAllocatedTps`,
    smsAdminSettingUpdate: `${version}sms/adminSettingUpdate`,
    getSmsAdminSettings: `${version}sms/getAdminSettings`,
    getValidityPeriodSetting: `${version}sms/getValidityPeriodSetting`,
    updateValidityPeriodSetting: `${version}sms/updateValidityPeriodSetting`,
    testGatewayConnection: `${version}sms/testGatewayConnection`,
  };
  const baseUrl = getApiUrl();
  const routeEndPoint = Object.entries(routes).find((item) => item[0] === title);
  return `${baseUrl}${routeEndPoint[1]}`;
}

export function MailFilterEndpoint(title) {
  const version = 'v1/';

  const routes = {
    getMailFilterDetails: `${version}mailFilter/getMailFilterDetails`,
    updateMailFilters: `${version}mailFilter/updateMailFilters`,
  };

  const baseUrl = 'https://console.sarv.com/mail-internal-api/';

  const endpoint = routes[title];
  if (!endpoint) {
    throw new Error(`Invalid route title: "${title}". Available routes are: ${Object.keys(routes).join(', ')}`);
  }
  return `${baseUrl}${endpoint}`;
}

export const GOOGLE_AUTH_CLIENT_ID = '260883182254-ocms377kdscmpnve27d65n0mglfo2m2o.apps.googleusercontent.com';

export const URL_MAPPER = {
  console: 'https://console.sarv.com',
};
